var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlan3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41.4171,
    height: 41.4171,
    rx: 20.7086,
    fill: "#356C37"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0801 20.7086L20.3999 24.8686C20.5131 24.9251 20.5697 24.9534 20.6291 24.9646C20.6817 24.9744 20.7356 24.9744 20.7882 24.9646C20.8476 24.9534 20.9042 24.9251 21.0173 24.8686L29.3372 20.7086M12.0801 25.0229L20.3999 29.1828C20.5131 29.2394 20.5697 29.2677 20.6291 29.2789C20.6817 29.2887 20.7356 29.2887 20.7882 29.2789C20.8476 29.2677 20.9042 29.2394 21.0173 29.1828L29.3372 25.0229M12.0801 16.3943L20.3999 12.2344C20.5131 12.1778 20.5697 12.1495 20.6291 12.1384C20.6817 12.1285 20.7356 12.1285 20.7882 12.1384C20.8476 12.1495 20.9042 12.1778 21.0173 12.2344L29.3372 16.3943L21.0173 20.5543C20.9042 20.6109 20.8476 20.6392 20.7882 20.6503C20.7356 20.6602 20.6817 20.6602 20.6291 20.6503C20.5697 20.6392 20.5131 20.6109 20.3999 20.5543L12.0801 16.3943Z",
    stroke: "white",
    strokeWidth: 1.72571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan3);
export default __webpack_public_path__ + "static/media/plan3.b1379122ee5da0f7231e30d5e9cb71dd.svg";
export { ForwardRef as ReactComponent };